////********** TODO - refaktorovat **********////

$(function() {
    setupOrderForm();
    setupCheckPromoCode();
});

//#region SETUP
function setupOrderForm() {

    var table = $('table.orderTable');
    if (table.length == 0) return; 


    setOrderFormDefaults(table);
    setupOrderFormEvents(table);

    setupPreventSubmitWithEnterKey();

    if(table.attr('data-addCompanyAffilPartnerDiscount') == true) {
        addCompanyAffilPartnerDiscount();
    }
}

function setOrderFormDefaults(table) {
    
    $('.pricePerUnit').val(table.attr('data-pricePerUnit')).change();
    $('.count').val(table.attr('data-defaultLicencesCount')).change();
    
    $('.active-order-row').addClass('licences-row');
    
    $('tr.display-none', table).each(function() {
        $(this).children().each(function() {
            $(this).children().prop('disabled', true);
        });
    })

    recalculateRowPrice(1);
    setNormalInvoiceText(); 
}

function setupOrderFormEvents(table) {

    const pricePerUnit = table.attr('data-pricePerUnit');

    setupFiltersEvents(table, pricePerUnit);
    setupSpecialLicencesFiltersEvents(table);

    setupFormEvents(table, pricePerUnit);
    setupSpecialLicencesFormEvents(table);
}
function setupFiltersEvents(table, pricePerUnit) {

    setupLicencesCount(table);
    setupYearSelect(table, pricePerUnit);

    $('select.beginningSelect').change(function() {
        setNormalInvoiceText();
        setSpecialInvoiceText();
    });

}
function setupFormEvents(table, pricePerUnit) {
    
    $('select.itemType.normal').change(function() {

        rowNumber = $(this).attr('data-row');
        selectAction = $('option:selected', this).attr('data-action');

        if(!selectAction) return;

        var thisRow = $('tr').filter("[data-row='" + rowNumber + "']");
        thisRow.removeClass('percentageDiscount');

        if(selectAction.includes('discount')) {
            $('input.count-' + rowNumber).hide().val(1);
            $('input.pricePerUnit-' + rowNumber).val(0);

            thisRow.addClass('discount');


            if(selectAction == 'discountPercentage') {
                $('input.pricePerUnit-' + rowNumber).attr('data-isPercentageDiscount', true);
                thisRow.addClass('percentageDiscount');

                calculatePercentageDiscount(rowNumber);

            }else {
                $('input.pricePerUnit-' + rowNumber).attr('data-isPercentageDiscount', false);
            }
            
            recalculateRowPrice(rowNumber, true);


        } else {
            $('input.pricePerUnit-' + rowNumber).attr('data-isPercentageDiscount', false).val(pricePerUnit);
            $('input.count-' + rowNumber).show().val(getLicencesCount()).change();
            
            $('tr').filter("[data-row='" + rowNumber + "']").removeClass('discount');
            

            recalculateRowPrice(rowNumber, false);
        } 

    });

    $('input.count').change(function() {
        
        recalculateAllPercentageDiscounts();
        isDiscount = $(this).closest('tr').hasClass('discount');
        
        recalculateRowPrice($(this).attr('data-row'), isDiscount);
        
        recalculateAllPercentageDiscounts();
        
        recalculateRowPrice($(this).attr('data-row'), isDiscount);


        setNormalInvoiceText();
        setSpecialInvoiceText();
    });

    $('input.pricePerUnit').change(function() {
        rowNumber = $(this).attr('data-row');
        
        if($(this).attr('data-isPercentageDiscount') == 'true') {
            calculatePercentageDiscount(rowNumber);
        }


        newRowPrice = $(this).val() * $('.count-' + rowNumber).val();

        isDiscount = $(this).closest('.orderItem').hasClass('discount');
        if(isDiscount) {
            newRowPrice = -newRowPrice;
        }
        
        $('.price-' + rowNumber).val(newRowPrice);
        
        recalculateAllPercentageDiscounts();
        recalculateTotalPrice();
    });


    $('a.addOrderItem', table).click(function(e) {

        var type = $(this).data('type');
        if(type == "normal") {
            addRowNormal(table);
        } else {
            addRowSpecial(table);
        }


        displayaddOrderItemLink(table, $(this), type);
    });

    $('.removeOrderItem', table).click(function(e) {
        removeRow(table, null, parseInt($(this).attr('data-row')));
    });    
}

function setupLicencesCount(table) {

    var updateLicencesCountSelect = function() {

        updateLicencesItemTypes('option', false)
        $('.custom-licences-count-container').hide();

        selectedOption = $('option:selected', 'select.licencesCountSelect');
        setCountForLicenceRows(selectedOption.val());
        updateQuantityDiscount(table, selectedOption);

        if(selectedOption.attr('data-action') == 'standard-licences') {
            updateLicencesItemTypes('option[data-action=licence]', true);

        } else if(selectedOption.attr('data-action') == 'custom-licences') {
            updateLicencesItemTypes('option[data-action=licence]', true);

            $('.custom-licences-count-container').show().change();
            updateLicencesItemTypes($('input.custom-licences-count').val());

        } else {
            updateLicencesItemTypes('option[data-action=other]', true);
        }

        updateYearDiscount();

    }


    updateLicencesCountSelect();
    $('select.licencesCountSelect').change(function() {
        updateLicencesCountSelect();
    });


    setCountForLicenceRows($('input.custom-licences-count').val());
    $('input.custom-licences-count').change(function() {
        setCountForLicenceRows($(this).val());
    });

}
function setupYearSelect(table,pricePerUnit) {
    $('select.yearSelect').change(function() {

        var selectValue = $(this).val();
        
        if(selectValue != "unlimited") 
        {
            $('.unlimitedLicence').each(function() {
                $(this).removeClass('unlimitedLicence');
                recalculateRowPrice($(this).attr('data-row'), false);
            })

            addRowsBasedOnYear(table, this, 'licences-row', true, pricePerUnit);
    
            updateYearDiscount();
            setNormalInvoiceText();
    
    
            areSpecialLicencesAllowed = $('#allowSpecialLicences').prop('checked');
            if(areSpecialLicencesAllowed) 
            {
                addRowsBasedOnYear(table, this, 'special');
                setSpecialInvoiceText();
            }  
        } else 
        {
            var calcConfig = $('.school-calc-config');

            $('.active-order-row.normal:not(.discount)').each(function(index, element) {

                $(this).addClass('unlimitedLicence');
                $('.pricePerUnit', this).val(calcConfig.attr('data-pricePerUnlimitedLicence'));

                recalculateRowPrice($(this).attr('data-row'), false);
                setNormalInvoiceText();

            });
        }

       

    });
}


//#region SPECIAL LICENCES
function displaySpecialLicences(table, allow, specialLicencesElements) {

    if(allow) 
    {
        specialLicencesElements.forEach(function(element) {
            $(element).show();
        });

        $('.finalTotalPriceRow').show();
        $('.normalTotalPrice').removeClass('totalPrice');
        $('.normalTotalPrice').removeAttr('data-totalPrice');    
       
        addRowSpecial(table);

        addRowsBasedOnYear(table, $('.yearSelect'), 'special');
        setSpecialInvoiceText();
    } 
    else 
    {
        specialLicencesElements.forEach(function(element) {
            $(element).hide();
        });

        $('.finalTotalPriceRow').hide();
        $('.normalTotalPrice').addClass('totalPrice');
        recalculateTotalPrice();

        for(i = 0; i <= $("tr.special", table).length; i++) 
        {
            removeRow(table, 'special');
        }
    }
}

function setupSpecialLicencesFiltersEvents(table) {
    
    setupSpecialLicencesCount(table);

    setupSpecialLicencesTypeSelect(table);
}
function setupSpecialLicencesFormEvents(table) {

    var specialLicencesElements = [
        $('.specialHidden'),
        $('.specialLicencesCountContainer'),
        $('.specialLicencesTypeSelect'),
    ];
   
    displaySpecialLicences(table, 0, specialLicencesElements);


    $('#allowSpecialLicences').change(function() 
    {
        var allow = $('#allowSpecialLicences').prop('checked');
        displaySpecialLicences(table, allow, specialLicencesElements);
    });
}


function setupSpecialLicencesCount(table) {

    $('.specialLicencesCount').change(function() 
    {
        var rows = $('tr.special.active-order-row', table);

        rows.each(function() 
        {
            $('input.count', $(this)).val($('.specialLicencesCount').val()).change();
            $('input.pricePerUnit', $(this)).change();
        });
       
        setSpecialInvoiceText();
    });
}
function setupSpecialLicencesTypeSelect(table) {

    $('.specialLicencesTypeSelect').change(function() 
    { 
        value = $(this).find(':selected').val();
        rows = $('tr.special:not(.display-none)');

        rows.each(function() 
        {
            $('.itemType option', $(this)).each(function() 
            {
                if($(this).val() != value) 
                {
                    $(this).removeAttr('selected');
                } 
                else 
                {
                    $(this).prop('selected', true).change();
                }
            });
            
        });   
    })


    $('select.itemType.special').change(function() 
    {
        var selectedOption = $(this).find(':selected');
        var rowNumber = $(this).data('row');

        var price = calclutePriceForSpecialLicences(selectedOption);

        $('.pricePerUnit-' + rowNumber).val(price).change();

        setSpecialInvoiceText();
    })

}
//#endregion

//#endregion


//#region SET/GET/UPDATE
function setCountForLicenceRows(value) {

    $('select.itemType.normal').each(function(index, element) {

        if($('option:selected', element).val() != null) {

            if($('option:selected', element).val().toLowerCase() == 'licence') {
                $('input.count-' + $(element).attr('data-row')).val(value);
            }

        }
        
        $('input.pricePerUnit').change();
        
    });

    $('.orderItem').each(function(index, element) 
    {   
        rowNumber = index + 1;
        isDiscount = $(element).hasClass('discount');

        recalculateRowPrice(rowNumber, isDiscount);
        recalculateAllPercentageDiscounts();
        recalculateRowPrice(rowNumber, isDiscount);
    });
    

    setNormalInvoiceText();
}

function updateLicencesItemTypes(option, isSelected) {
    notDiscountRows = $('tr.normal.active-order-row').not('.discount');

    $('select.itemType.normal ' + option, notDiscountRows).prop('selected', isSelected).change()
}

function getLicencesCount() {

    licencesCountSelectedOption = $('option:selected', 'select.licencesCountSelect');

    if(licencesCountSelectedOption.attr('data-action') != 'custom-licences') {
        return licencesCountSelectedOption.val();

    } else {
        return $('input.custom-licences-count').val();
    }
}
function getYear(yearOffset) {
    var date = new Date();   

    if(yearOffset == null) {
        yearOffset = 0;
    }

    return date.getFullYear() + parseInt(yearOffset);
}
function getRowAction() {

    selectedOption = $('option:selected', 'select.licencesCountSelect');


    if(selectedOption.attr('data-action') != 'other-action') {
        return 'licence';
    } else {
        return 'other';
    }
}
//#endregion


//#region INVOICE TEXT
function setNormalInvoiceText() {

    licencesRows = $('tr.active-order-row.licences-row');
    invoiceTextOption = $('option:selected', 'select.beginningSelect').val();

    yearAndText = getYearAndBeginningText();
    year = yearAndText[0];
    beginningText = yearAndText[1];

    licencesRows.each(function(index, element) {

        if($('.itemType.normal option:selected', this).val() === 'licence') {

            if($('table.orderTable').attr('data-institutionType') == 'school') {
                
                if(!$(element).hasClass('unlimitedLicence')) 
                {
                    invoiceText = ($('.count', this).val() + 'x roční licence psaní všemi deseti pro ' + getInstitutionPlayerText()) + beginningText + year;
                } 
                else 
                {
                    invoiceText = ($('.count', this).val() + 'x neomezená licence psaní všemi deseti pro ' + getInstitutionPlayerText()) + beginningText + year;
                }

                $('.itemNote', this).val(invoiceText);
            
        
                if(invoiceTextOption == 'schoolYear') {
                    year = getYear(index + 1 + beforeHolydaysYear) + '/' + getYear(index + 2 + beforeHolydaysYear);
                } else {
                    year++;
                }

            } else {
                invoiceText = ($('.count', this).val() + 'x neomezená licence psaní všemi deseti pro ' + getInstitutionPlayerText());
                $('.itemNote', this).val(invoiceText);
            }

            
        } else {
            $('.itemNote', this).val(null);
        }

        
    
    });
    
}
function setSpecialInvoiceText() {

    licencesRows = $('tr.active-order-row.special');
    invoiceTextOption = $('option:selected', 'select.beginningSelect').val();

    yearAndText = getYearAndBeginningText();
    year = yearAndText[0];
    beginningText = yearAndText[1];

    licencesRows.each(function(index) {

        count = $('.count', $(this)).val() + 'x';

        licenceType = $('.itemType', $(this)).find(':selected').val();

        if(licenceType == 'visuallyImpaired') 
        {
            typeText = "licence adaptované verze pro " + getInstitutionPlayerText();
            discountTypeText = 'adaptovanou verzi ';    
        } 
        else if(licenceType == 'visuallyImpairedWithDivision') 
        {
            typeText = "zvýhodněná licence na adaptovanou verzi pro žáka " + getInstitutionPlayerText();
            discountTypeText = 'adaptovanou verzi ';
        } 
        else if(licenceType == 'specialSchool') 
        {
            typeText = "licence pro speciální školu ";
            discountTypeText = 'speciální školy ';
        }
        
        discount = $('td.specialLicencesInfo-' + licenceType).data('discount');


        invoiceText =  count + ' roční ' + typeText + 'se slevou ' + discount + ' % pro ' + discountTypeText + beginningText + year;

        $('.itemNote', this).val(invoiceText);

        if(invoiceTextOption == 'schoolYear') {
            year = getYear(index + 1 + beforeHolydaysYear) + '/' + getYear(index + 2 + beforeHolydaysYear);
        } else {
            year++;
        }
    });

}


function getInstitutionPlayerText() {
    switch($('table.orderTable').attr('data-institutionType')) {
        case 'school':
          return 'žáka ';
        case 'company':
            return 'zaměstnance ';
        case 'family':
            return 'člena rodiny ';
        default:
            return "";
    }
}
function getYearAndBeginningText() {
    var date = new Date();   
    if(invoiceTextOption == 'schoolYear') 
    {
        beforeHolydaysYear = date.getMonth() < 6 ? -1 : 0;
        year = getYear(beforeHolydaysYear) + '/' + getYear(beforeHolydaysYear + 1);
        beginningText = 'na školní rok ';
    } 
    else if(invoiceTextOption == 'now') 
    {
        var date = $('option:selected', 'select.beginningSelect').attr('data-date');
        beginningText = 'od ' + date + ' ';
        year = year = getYear(offset);
    }
    else 
    {
        var offset = parseInt($('option:selected', 'select.beginningSelect').attr('data-yearOffset'));
        year = getYear(offset);
        beginningText = 'od září ';
    }

    return [
        year,
        beginningText,
   ];
}
//#endregion


//#region ADD/REMOVE ROWS
function addRowNormal(table, values, rowClass, rowPosition) {
    
    var hiddenRows = $('tr.display-none.normal', table);
    var rowsInTable = $('tr.normal', table);

    addRow(table, hiddenRows, rowsInTable, values, rowClass, rowPosition);

}
function addRowSpecial(table, values, rowClass, rowPosition) {
    var hiddenRows = $('tr.display-none.special', table);
    var rowsInTable = $('tr.special', table);

    if(values == null || values == "undefined") 
    {
        var selectedLicenceType =  $('.specialLicencesTypeSelect').find(':selected');
        var price = calclutePriceForSpecialLicences(selectedLicenceType);

        var count = $('.specialLicencesCount').val();

        var values = [
            selectedLicenceType.val(),
            count,
            '',
            price
        ];
    }

    addRow(table, hiddenRows, rowsInTable, values, rowClass, rowPosition);
}
function addRow(table, hiddenRows, rowsInTable, values, rowClass, rowPosition) {

    if(rowClass == undefined) {
        rowClass = '';
    }


    if(rowPosition == null || rowPosition >= rowsInTable.length) {
        rowToAdd = hiddenRows.first();

    } else {
        rowToAdd = hiddenRows.eq(rowPosition);
    }
  

    rowToAdd.removeClass('display-none').addClass('active-order-row ' + rowClass);

    rowToAdd.children().each(function(index) {
            
        $(this).children().prop('disabled', false);

        if(values != null) {
            if($(this).children().is("select")) {
                $("[data-action='" + values[index] + "']", $(this).children()).prop('selected', true).change();
            } else {
                $(this).children().val(values[index]).change();
            }
        }
        
    });


    displayaddOrderItemLink(table, $('.' + rowToAdd.data('type') + 'OrderItemLink') ,rowToAdd.data('type'))


    recalculateAllPercentageDiscounts();

    isDiscount = rowToAdd.hasClass('discount');
    recalculateRowPrice(rowToAdd.attr('data-row'), isDiscount);

    setNormalInvoiceText();
    setSpecialInvoiceText();
}

function addRowsBasedOnYear(table, yearSelect, rowClass, isWithDiscount, pricePerUnit) {

    licencesRowsInFormCount = $('tr.orderItem.active-order-row.' + rowClass, table).length;
    years = $('option:selected', yearSelect).val();

    rowsToChangeCount = years - licencesRowsInFormCount;

    if(rowsToChangeCount > 0) 
    {
        for(var i = 0; i < rowsToChangeCount; i++) 
        {

            if(rowClass == 'licences-row') 
            {
                rowValues = [
                    getRowAction(),
                    getLicencesCount(),
                    null,
                    pricePerUnit,
                ];
                addRowNormal(table, rowValues, 'licences-row');
            } 
            else if (rowClass == 'special') 
            {
                addRowSpecial(table);
            }
        }
    } 
    else 
    {
        for(var i = 0; i < -rowsToChangeCount; i++) {
            removeRow(table, rowClass);
        }

        if(isWithDiscount) {
            removeRow(table, 'year-discount');
        }
    }
}


function removeRow(table, rowClass, rowPosition) {
    
    if(rowPosition == null) {
        var visibleRows = $('tr.active-order-row.' + rowClass, table);

        if(rowClass == 'special') {
            rowClass = '';
        }

        rowToRemove = visibleRows.last().addClass('display-none').removeClass('active-order-row ' + rowClass);

    } else {

        rowToRemove = $('tr.orderItem', table).eq(rowPosition - 1);
        if(rowToRemove.hasClass('normal')) {
            var classToAdd = 'normal';
        } else {
            var classToAdd = 'special';
        }

        rowToRemove.removeAttr('class').addClass('orderItem display-none ' + classToAdd);
    }
    

    if(rowToRemove.hasClass('discount')) {
        rowToRemove.removeClass('discount');
    }

    rowToRemove.children().each(function() {
        $(this).children().val(null).prop('disabled', true);
    });


    displayaddOrderItemLink(table, $('.' + rowToRemove.data('type') + 'OrderItemLink') ,rowToRemove.data('type'))

    recalculateAllPercentageDiscounts();
    recalculateTotalPrice();
}


function displayaddOrderItemLink(table, linkObject, type) {

    var hiddenRows = $('tr.display-none.' + type, table);

    if (hiddenRows.length <= 0) 
    {
        linkObject.hide();
    } 
    else 
    {
        linkObject.show();
    }

}
//#endregion


//#region DISCOUNT
function updateQuantityDiscount(table, selectedOption) {
    
    //ZRUŠENO - až od 31. 12. 2024
    // return;

    if(selectedOption.attr('data-discount') > 0) {    
            
        discountValues = [
            'discountPercentage',
            1,
            'Sleva ' + selectedOption.attr('data-discount') + ' % za počet žáků',
            selectedOption.attr('data-discount'),
        ];
        updateDiscounts(table, 'quantity-discount', discountValues);

    }else {
        removeRow(table, 'quantity-discount');
    }
}
function updateYearDiscount() {

    if($('.licencesCountSelect option:selected').attr('data-action') != 'other-action') {
        
        var licencesRowsCount = $('tr.active-order-row.licences-row').length;
        if(licencesRowsCount > 1) {

            years = $('option:selected', 'select.yearSelect').val();
            if(years === undefined) { return; }

            var discoutPerYearValues = [0, 10, 15, 20, 25];

            discountValues = [
                'discountPercentage',
                1,
                'Sleva ' + discoutPerYearValues[years - 1] + ' % za počet let',
                discoutPerYearValues[years - 1],
            ];

            var table = $('table.orderTable');
            updateDiscounts(table, 'year-discount', discountValues);

        } 
    }else {
        removeRow(table, 'year-discount');
    }
}

function updateDiscounts(table, discountName, values) {        

    var discountRow = $('tr.active-order-row.' + discountName, table);

    if(discountRow.length != 1) 
    {
        addRowNormal(table, values, discountName + ' discount', getDiscountPositionForNormalRows(discountName));
    }
    else 
    {
        $('.itemType', discountRow).change();
        $('.pricePerUnit', discountRow).val(values[3]).change();
        $('.itemNote', discountRow).val(values[2]);

        recalculateAllPercentageDiscounts();
    }
}

function getDiscountPositionForNormalRows(discountName) {
    var hiddenRows = $('tr.display-none.normal');
    
    if(discountName == 'promo-code-discount') {
        return hiddenRows.length - 1;
    } else {
        return hiddenRows.length - 2;
    }
}


function calculatePercentageDiscount(rowNumber) {
    wholePrice = 0;

    $('input.price', 'tr.orderItem.normal.active-order-row').each(function() {
        if($(this).attr('data-row') < rowNumber) {
            wholePrice += parseInt($(this).val()) || 0;
        }
    });

    discount = (wholePrice / 100) * $('input.pricePerUnit-' + rowNumber).val();
    $('input.pricePerUnit-' + rowNumber).attr('data-discountValue', discount);

    recalculateRowPrice(rowNumber, true);
}
function recalculateAllPercentageDiscounts() {


    $('tr.active-order-row.percentageDiscount').each(function() {
        calculatePercentageDiscount($(this).attr('data-row'));
    });

}
//#endregion


//#region PRICE CALCULATIONS
    
    //#region SCHOOL PRICING
    function calcSchoolPrice_CRM(count, rowNumber) {

        var formatCurrency = function(amount) {
            return Math.floor(amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " " + $('.school-calc-config').attr('data-currency');
        }

        var calcConfig = $('.school-calc-config');
        var smallClassCount = calcConfig.attr('data-smallClassCount');


        if(parseInt(count) <= parseInt(smallClassCount)) 
        {
            var pricePerLicence = calcConfig.attr('data-smallClassPricePerLicence');
            var discountPercentage = 0;
        } 
        else 
        {
            var pricePerLicence = calcConfig.attr('data-pricePerLicence');
            var discountPercentage = Math.round(getDiscountForSchoolCount_CRM(count));
        }

        var defaultPricePerLicence = calcConfig.attr('data-smallClassPricePerLicence');;


        finalPrice = pricePerLicence * count;
        discount = roundByStep(finalPrice * (discountPercentage / 100), 0.50);
        finalPrice = finalPrice - discount;

        pricePerLicence = Math.ceil(finalPrice / count);

        const minimumPricePerLicence = calcConfig.attr('data-minimumPricePerLicence');
        if(pricePerLicence <= minimumPricePerLicence) { pricePerLicence = minimumPricePerLicence; }

        finalPrice = Math.ceil(pricePerLicence * count); 
        
        $('.pricePerUnit-' + rowNumber).val(pricePerLicence);
        $('.price-' + rowNumber).val(finalPrice);

        $('.pupilBasePrice').text(formatCurrency(defaultPricePerLicence));
        $('.pricePerPupil').text(formatCurrency(pricePerLicence));
        $('.pupilCount').text(count);
        $('.pricePerYear').text(formatCurrency(finalPrice));

        var years = $('option:selected', 'select.yearSelect').val();
        var countDiscount = (defaultPricePerLicence - pricePerLicence) * count;
        $('.countDiscount').text(formatCurrency(countDiscount));
        $('.pupilsCountDiscount').text(formatCurrency(countDiscount * years))

        if(years > 1) {
            $('.onlyMultipleYears').show();
        } else {
            $('.onlyMultipleYears').hide();
        }
        

        $('.yearsCount').text(years);
        
        if(years > 1 && years < 5) {
            var yearsDescriptionText = "roky";
        } else if (years > 1) {
            var yearsDescriptionText = "let";
        } else {
            var yearsDescriptionText = "rok";
        }
        $('.yearsCountDescription').text(yearsDescriptionText);
        
        $('.priceForYears').text(formatCurrency(years * finalPrice));
        
        var discoutPerYearValues = [0, 10, 15, 20, 25];
        var yearDiscount = discoutPerYearValues[years - 1];
        $('.discountForYears').text(yearDiscount + " %");


        //For price calculation table
        const pricePerLicenceFor2Years = pricePerLicence - (pricePerLicence * 0.10);
        const pricePerYearFor2Years = pricePerLicenceFor2Years * count;
        const totalPriceFor2Years = pricePerYearFor2Years * 2;

        $('.pricePerPupil2').text(formatCurrency(pricePerLicenceFor2Years));
        $('.pricePerYear2').text(formatCurrency(pricePerYearFor2Years));
        $('.totalPriceForYear2').text(formatCurrency(totalPriceFor2Years));
        
        const pricePerLicenceFor3Years = pricePerLicence - (pricePerLicence * 0.15);
        const pricePerYearFor3Years = pricePerLicenceFor3Years * count;
        const totalPriceFor3Years = pricePerYearFor3Years * 3; 

        $('.pricePerPupil3').text(formatCurrency(pricePerLicenceFor3Years));
        $('.pricePerYear3').text(formatCurrency(pricePerYearFor3Years));
        $('.totalPriceForYear3').text(formatCurrency(totalPriceFor3Years));
        //For price calculation table

        
        setTimeout(function() {
            $('.finalPriceText').text(formatCurrency(calculateTotalPriceForSegment('normal')));
        }, 100);


    }

    function getDiscountForSchoolCount_CRM(count) {

        var calcConfig = $('.school-calc-config');

        var discounts = calcConfig.attr('data-discounts').split(';');
        var usersForDiscount = calcConfig.attr('data-usersForDiscount').split(';');

        var discount = 0;

        jQuery.each(usersForDiscount, function(i, usersCount) {

        if(parseInt(count) >= parseInt(usersCount)) 
        {
            discount = discounts[i];

            if(parseInt(count) <= parseInt(usersForDiscount[usersForDiscount.length - 1])) 
            {
            diffFromCountBaseline = count - usersCount;
            
            if(diffFromCountBaseline > 0) 
            {
                nextDiscount = discounts[i + 1];

                discountDiff = nextDiscount - discount;
                usersCountDiff = usersForDiscount[i + 1] - usersCount;
    
                discountPart = (discountDiff / usersCountDiff);
    
                discount = parseInt(discount) + discountPart * diffFromCountBaseline;
            }
            }
        }

        });

        return discount;
    } 
    //#endregion


function recalculateRowPrice(rowNumber, isDiscount) {
    
    var row = $('#names-row-' + rowNumber);
    var isRowSpecial = $(row).hasClass('special');

    var canCalculateSchoolPrice = 
        $('table.orderTable').attr('data-institutionType') == 'school' && 
        isDiscount != true && 
        isRowSpecial == false && 
        !$(row).hasClass('unlimitedLicence');

    if(canCalculateSchoolPrice) 
    {
        var count = $('.count-' + rowNumber).val();
        calcSchoolPrice_CRM(count, rowNumber);
    } 
    else 
    {
        if($('.pricePerUnit-' + rowNumber).attr('data-isPercentageDiscount') == 'false') {
            basePrice = $('.pricePerUnit-' + rowNumber).val();
        } else {
            basePrice =  $('.pricePerUnit-' + rowNumber).attr('data-discountValue');
        }
    
        newRowPrice = Math.round($('.count-' + rowNumber).val() * basePrice);
    
    
        if(isDiscount) {
            newRowPrice = -newRowPrice;
        }
        
        $('.price-' + rowNumber).val(newRowPrice);
    }

    
    recalculateTotalPrice();
}

function calclutePriceForSpecialLicences(infoElement) {
    return infoElement.data('price') - (infoElement.data('price') * (infoElement.data('discount') / 100))
}


function recalculateTotalPrice() {

    normalTotalPrice = calculateTotalPriceForSegment('normal');
    specialTotalPrice = calculateTotalPriceForSegment('special');
    

    totalPrice = normalTotalPrice + specialTotalPrice;

    $('.totalPrice').text(totalPrice);
    $('.totalPrice').attr('data-totalPrice', totalPrice);
}
function calculateTotalPriceForSegment(segment) 
{
    totalPriceForSegment = 0;
    $('input.price', 'tr.orderItem.active-order-row.' + segment).each(function() 
    {
        totalPriceForSegment += parseInt(Math.round($(this).val())) || 0;
    });
    
    return totalPriceForSegment;
}
//#endregion


//#region ON-VALIDATION
function validateOrderForm(form, e) {
  
    var isValid = true;  

    $('tr.orderItem.active-order-row', form).each(function(rowNumber, element) {
  
        if($(this).hasClass('discount')) {
            if($('.pricePerUnit', this).attr('data-isPercentageDiscount') == 'true') {
                $('.pricePerUnit', this).val( Math.round($('.pricePerUnit', this).attr('data-discountValue') * (-1)) );
            }
            else {
                $('.pricePerUnit', this).val( Math.round($('.pricePerUnit', this).val() * (-1)));
            }
        }        
        
        
        if (parseInt($('input.price', this).val()) == 0) {
            isValid = false;
            alert('Cena řádku nesmí být nulová!')
            $('input.price', this).addClass('border-2-red');
        } 
  
        if ($('input.itemNote', this).val() == "") {
            isValid = false;
            alert('Je nutné vyplnit "text na fakturu"!');
            $('input.itemNote', this).addClass('border-2-red');
        }

    });
  
    var totalPrice = $('.totalPrice', form);
    if (parseInt(totalPrice.attr('data-totalPrice')) == 0) {
        isValid = false;
        alert('Celková cena nesmí být nulová!');
        totalPrice.closest('td').addClass('border-2-red');
    }
  

    e.preventDefault();

}
//#endregion


function setupPreventSubmitWithEnterKey() {
    $('#frm-OrderForm-form input').keydown(function (e) {
        preventSubmitWithEnterKey(e, this);
    });
    $('#frm-OrderForm-form select').keydown(function (e) {
        preventSubmitWithEnterKey(e, this);
    });
}

function preventSubmitWithEnterKey(e, t) {

    if (e.keyCode == 13) 
    {
        var inputs = $(t).parents("form").eq(0).find(":input:visible:not(:disabled)");


        if (inputs[inputs.index(t) + 1] != null) 
        {                                
            inputs[inputs.index(t) + 1].focus();

            e.preventDefault();
            return false;
        }
    }

    
}




function setupCheckPromoCode() {

    $('#newOrderButton').click(function() {
        $.ajax(
            { 
                url: $('#orderTable').attr('data-promoCodeValidationUrl'),
                data: {},
                success: function(result)
                {
                    if(!result.success) { return; }
                
    
                    discountValues = [
                        result.discountType == "%" ? 'discountPercentage' : 'discountCurrency',
                        1,
                        'Promo kód ' + result.code + ' - sleva ' + result.discountText,
                        result.discountValue,
                    ];
            
                    var table = $('table.orderTable');
                    updateDiscounts(table, 'promo-code-discount', discountValues);
                }
            }
        ); 
    });
}

function addCompanyAffilPartnerDiscount() 
{
    discountValues = [
        'discountPercentage',
        1,
        'Sleva 10 %',
        "10",
    ];

    var table = $('table.orderTable');
    updateDiscounts(table, 'affil-partner-discount', discountValues);
}







